import React, { createContext, useState } from "react";

export function createTrackingContext<T>(defaultState: T) {
	type ContextType = {
		state: T;
		setState: React.Dispatch<React.SetStateAction<T>>;
	};

	const DEFAULT_VALUE: ContextType = {
		state: defaultState,
		setState: () => {}
	};

	const Context = createContext<ContextType>(DEFAULT_VALUE);

	const Provider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
		const [state, setState] = useState<T>(defaultState);
		return (
			<Context.Provider value={{ state, setState }}>
				{children}
			</Context.Provider>
		);
	};

	return { Context, Provider };
}
